var global = {
  baseUrl: "https://excpay-file-download-prod-n.oss-cn-hangzhou.aliyuncs.com/static" // 1:为公众号端，2为android端，3为ios端
};

export default global;



// WEBPACK FOOTER //
// ./src/utils/global.js